module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.communityDetails) ? _c('b-modal', {
    ref: "communityLogoModal",
    attrs: {
      "id": "communityLogoModal",
      "title": _vm.$t('community.modal.logo'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setCommunityLogoData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.uploadCommunityLogo($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.communityLogoData.url) ? _c('div', {
    staticClass: "col text-center"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100px"
    },
    attrs: {
      "src": _vm.communityLogoData.url
    }
  }), _vm._v(" "), _c('br'), _c('br')]) : _c('div', {
    staticClass: "col text-center font-italic"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('community.logo.notSelected')) + "\n            "), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.logo'),
      "state": _vm.communityLogoState,
      "feedback": _vm.communityLogoFeedback,
      "description": _vm.$t('community.logo.description')
    }
  }, [_c('b-form-file', {
    ref: "communityLogoSelection",
    attrs: {
      "id": "communityLogoSelection",
      "accept": "image/jpeg, image/png, image/gif",
      "choose-label": _vm.$t('community.logo.choose')
    },
    model: {
      value: (_vm.communityLogoData.file),
      callback: function($$v) {
        _vm.communityLogoData.file = $$v
      },
      expression: "communityLogoData.file"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Community logo actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.uploadCommunityLogo
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.upload')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "danger",
      "disabled": !_vm.communityLogoData.url
    },
    on: {
      "click": _vm.deleteCommunityLogo
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideCommunityLogoModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf3d52f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/modals/CommunityLogoModal.vue
// module id = 574
// module chunks = 0